import { useState } from 'react'
import { Offer } from 'api/types'
import { buildTranslate } from 'locales'
import { ApplyOfferResult } from 'hooks/loyalty'
import OfferCard from 'components/OfferCard'
import { formatPointsBalance } from 'utils/loyalty'

const t = buildTranslate('customer.offerCard')

type Props = {
  offer: Offer
  onApplyOffer: (offer: Offer) => Promise<ApplyOfferResult>
  pointsCurrencySingular: string
  pointsCurrencyPlural: string
  isDisabled: boolean
}

const AvailableOfferCard = ({
  offer,
  isDisabled,
  onApplyOffer,
  pointsCurrencySingular,
  pointsCurrencyPlural,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  async function applyOffer() {
    setIsLoading(true)
    setError(null)
    const result = await onApplyOffer(offer)
    setIsLoading(false)
    if (result.isErr()) {
      setError(result.error)
    }
  }

  return (
    <OfferCard kind="available-offer" offerId={offer.id}>
      <OfferCard.Label>{offer.name}</OfferCard.Label>
      {offer.type === 'points_product' && (
        <OfferCard.Subtext>{`${formatPointsBalance(offer.points_cost)} ${
          offer.points_cost === 1
            ? pointsCurrencySingular
            : pointsCurrencyPlural
        }`}</OfferCard.Subtext>
      )}
      {!!error && <OfferCard.ErrorText>{error.message}</OfferCard.ErrorText>}
      <OfferCard.Button
        isLoading={isLoading}
        isDisabled={isDisabled}
        onClick={applyOffer}
      >
        {t('redeem')}
      </OfferCard.Button>
    </OfferCard>
  )
}

export default AvailableOfferCard
